import React, {useEffect} from 'react'
import Profile from '../../Components/Profile/Profile'
import styles from '../../Components/Profile/Profile.module.css';  // Import CSS Module styles
import { useTranslation } from "react-i18next";
import { useDispatch , useSelector} from 'react-redux';
import { getOneUser } from '../../redux/Slices/users/thunk';
import Spinner from 'react-bootstrap/Spinner';

 function ProfilePage() {
    const { t, i18n } = useTranslation();
    const user = JSON.parse(localStorage.getItem('user'));
    const { oneUser } = useSelector((state) => state.usersSlice);

  const dispatch = useDispatch();
  useEffect(()=>{
    dispatch(getOneUser(user?.cln_key))
  },[])
  return (
    <div className='flex-grow-1'>
    <div className={styles.loginContainer}>
    <div className={styles.loginHeader}>{t("profilePage")}</div>

      </div>
     {oneUser ? <Profile oneUser={oneUser} />
     : <div style={{display:"flex", justifyContent:"center"}}>

     <Spinner animation="border" role="status" style={{width:"100px", height:"100px"}}/>
    </div>}
    </div>
  )
}
export default ProfilePage
